import React, { Component } from "react";

import FilterDropDown from "./components/FilterDropDown";

export default class LevaeReportFilters extends Component {
  constructor(props) {
    super(props);
    // We have filtereValues data in LeaveReport.jsx
    // We also need these as states here to hundle employeeInfoDropDownList.
    this.state = {
      filterValues: {
        selectedRegion: 0,
        selectedBranch: 0,
        selectedDepartment: 0,
        selectedExitStatus: 0,
      },
    };
  }

  get employeeInfoDropDownList() {
    let employeesInfo = this.props.employeesInfo;
    const { filterValues } = this.state;

    if (filterValues.selectedRegion !== 0) {
      employeesInfo = employeesInfo.filter((employeeInfo) => {
        return employeeInfo.regionId === filterValues.selectedRegion;
      });
    }

    if (filterValues.selectedBranch !== 0) {
      employeesInfo = employeesInfo.filter((employeeInfo) => {
        return employeeInfo.branchId === filterValues.selectedBranch;
      });
    }

    if (filterValues.selectedDepartment !== 0) {
      employeesInfo = employeesInfo.filter((employeeInfo) => {
        return employeeInfo.departmentId === filterValues.selectedDepartment;
      });
    }

    employeesInfo = employeesInfo.filter((employeeInfo) => {
      return employeeInfo.discontinued === filterValues.selectedExitStatus;
    });

    if (employeesInfo.length > 0) employeesInfo.unshift({ userId: 0 });

    return employeesInfo.map((employeeInfo) => {
      if (employeeInfo.userId === 0) {
        return { value: 0, label: "ALL" }; // Empty selection
      }

      return {
        value: employeeInfo.userId,
        label: `(${employeeInfo.employmentId}) ${employeeInfo.name}`,
      };
    });
  }

  get exitStatusList() {
    return [
      { label: "Active", value: 0 },
      { label: "Exit", value: 1 },
    ];
  }

  handleFilterValue = (filter, value) => {
    const currentFilters = this.state.filterValues;
    if (currentFilters[filter] === value) return;
    currentFilters[filter] = value;
    if (filter !== "selectedEmployee") {
      // When other filters are selected, we clear this selected employee.
      this.props.handleFilterValue("selectedEmployee", 0);
    }

    this.setState({
      filterValues: currentFilters,
    });
  };

  handleDepartment = (val) => {
    this.handleFilterValue("selectedDepartment", val);
    this.props.handleFilterValue("selectedDepartment", val);
  };

  handleBranch = (val) => {
    this.handleFilterValue("selectedBranch", val);
    this.props.handleFilterValue("selectedBranch", val);
  };

  handleRegion = (val) => {
    this.handleFilterValue("selectedRegion", val);
    this.props.handleFilterValue("selectedRegion", val);
  };

  handleEmployeeName = (val) => {
    this.props.handleFilterValue("selectedEmployee", val);
  };

  handleExitStatus = (val) => {
    this.handleFilterValue("selectedExitStatus", val);
    this.props.handleFilterValue("selectedExitStatus", val);
  };

  render() {
    return (
      <div className="row ">
        <FilterDropDown
          label="Region"
          dropDownList={this.props.regions}
          handleSelect={this.handleRegion}
          placeholder="Please Choose Region"
          htmlFor="region-name"
        />
        <FilterDropDown
          label="Branch"
          dropDownList={this.props.branches}
          handleSelect={this.handleBranch}
          placeholder="Please Choose Branch"
          htmlFor="branch-name"
        />
        <FilterDropDown
          label="Department"
          dropDownList={this.props.departments}
          handleSelect={this.handleDepartment}
          placeholder="Please Choose Department"
          htmlFor="department-name"
        />
        <FilterDropDown
          key={`${this.state.filterValues.selectedRegion} ${this.state.filterValues.selectedBranch} ${this.state.filterValues.selectedDepartment} ${this.state.filterValues.selectedExitStatus}`}
          label="Employee Name"
          initialValue={{ value: 0, label: "ALL" }}
          dropDownList={this.employeeInfoDropDownList}
          handleSelect={this.handleEmployeeName}
          placeholder="Please Choose Employee Name"
          htmlFor="employee-name"
        />
        <FilterDropDown
          label="Exit Status"
          initialValue={this.exitStatusList[0]}
          dropDownList={this.exitStatusList}
          handleSelect={this.handleExitStatus}
          placeholder="Please Choose Status"
          htmlFor="employee-name"
        />
      </div>
    );
  }
}
